// Placeholder for a footer to replace the old `react-web-app` footer

const Footer = () => null;

export default Footer;
